import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/api/auth.service';
import { APP_ROUTES } from '../models/constants';

export const authGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.isLogged()) return true;

    router.navigate([APP_ROUTES.LOGIN]);
    return false;
};

export const publicGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!auth.isLogged()) return true;

    router.navigate([auth.isSolicitante() ? APP_ROUTES.TICKETS : APP_ROUTES.DASHBOARD]);
    return false;
};

export const roleGuard: CanActivateFn = (route) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const allowedRoles = route.data?.['roles'] as string[] | undefined;

    if (!allowedRoles || allowedRoles.length === 0) return true;
    if (auth.hasRole(...allowedRoles)) return true;

    // SOLICITANTE no tiene Dashboard: su landing es Tickets
    router.navigate([auth.isSolicitante() ? APP_ROUTES.TICKETS : APP_ROUTES.DASHBOARD]);
    return false;
};
